import { takeEvery, put, select } from 'redux-saga/effects';
import { 
  afterSaveUWNavigate,
  setTransientValuation
} from 'store/actions';
import { selectedValuationSelector } from 'store/selectors';

export function* afterSaveUWNavigateSaga() {
  yield takeEvery(afterSaveUWNavigate, function* ({ payload }) {
    if (payload.resetTransient) {
      const selectedValuation = yield select(selectedValuationSelector);
      yield put(setTransientValuation(selectedValuation));
    }
    navigate(payload)
  });
}

function navigate(payload) {
  const { history, route } = payload
  if (route) {
    history.push(route);
  }
};